import { Franchise } from "../../types";

/**
 * @param tableNumber
 * @param selectedFranchise
 * @param franchiseSlug
 * @returns
 */
export const validateTableForFranchise = (
  tableNumber: number,
  selectedFranchise: Franchise | null,
  franchiseSlug?: string
): boolean => {
  if (!selectedFranchise) {
    return false;
  }

  if (franchiseSlug && selectedFranchise.slug !== franchiseSlug) {
    return false;
  }

  if (
    !selectedFranchise.franchiseTable ||
    selectedFranchise.franchiseTable.length === 0
  ) {
    return true;
  }

  const tableExists = selectedFranchise.franchiseTable.some(
    (table) => table.tableNumber === tableNumber
  );

  return tableExists;
};
